const angular = require('angular');
const uiRouter = require('angular-ui-router');

const olyCommonModule = require('../olycommon/olycommon.module');
const wowCommonModule = require('../common/common.module');
const analyticsModule = require('../analytics/analytics.module');
const digitalPayModule = require('../digitalpay/digitalpay.module');

const DeliverySaverConstants = require('./delivery-saver.constants');
const { DeliverySaverComingSoonComponentDefinition } = require('./comingsoon/delivery-saver-coming-soon.component');
const { DeliverySaverPlanSelectionComponentDefinition } = require('./planselection/delivery-saver-plan-selection.component');
const { DeliverySaverPlanGroupComponentDefinition } = require('./plangroup/delivery-saver-plan-group.component');
const { DeliverySaverPlanComponentDefinition } = require('./plan/delivery-saver-plan.component');
const { DeliverySaverPlanDetailComponentDefinition } = require('./plandetail/delivery-saver-plan-detail.component');
const { DeliverySaverSubscriptionDetailComponentDefinition } = require('./subscriptiondetail/delivery-saver-subscription-detail.component');
const { DeliverySaverPlanTagComponentDefinition } = require('./plantag/delivery-saver-plan-tag.component');
const { DeliverySaverPaymentSetupComponentDefinition } = require('./paymentsetup/delivery-saver-payment-setup.component');
const { DeliverySaverConfirmationComponentDefinition } = require('./confirmation/delivery-saver-confirmation.component');
const { DeliverySaverPaymentUpdateComponentDefinition } = require('./paymentupdate/delivery-saver-payment-update.component');
const { DeliverySaverBillingAddressComponentDefinition } = require('./billingaddress/delivery-saver-billing-address.component');
const { MyDeliverySaverComponentDefinition } = require('./mydeliverysaver/mydeliverysaver/my-delivery-saver.component');
const { MyDeliverySaverManagementComponentDefinition } = require('./mydeliverysaver/management/my-delivery-saver-management.component');
const { MyDeliverySaverPanelComponentDefinition } = require('./mydeliverysaver/panel/my-delivery-saver-panel.component');
const { MyDeliverySaverPaymentMethodComponentDefinition } = require('./mydeliverysaver/paymentmethod/my-delivery-saver-payment-method.component');
const { MyDeliverySaverPaymentsComponentDefinition } = require('./mydeliverysaver/payments/my-delivery-saver-payments.component');

const DeliverySaverBillingFrequency = require('./delivery-saver-billing-frequency.filter');
const DeliverySaverBillingFrequencyUnit = require('./delivery-saver-billing-frequency-unit.filter');
const DeliverySaverPaymentAmountHeading = require('./delivery-saver-payment-amount-heading.filter');
const DeliverySaverShortName = require('./delivery-saver-short-name.filter');
const DeliverySaverTypeName = require('./delivery-saver-type-name.filter');
const DeliverySaverFullTypeName = require('./delivery-saver-full-type-name.filter');

const { DeliverySaverService } = require('./delivery-saver.service');
const { MyDeliverySaverService } = require('./mydeliverysaver/my-delivery-saver.service');
const { DeliverySaverAnalytics } = require('./delivery-saver-analytics.service');

const deliverySaverModuleName = 'wowApp.deliverysaver';

angular.module(deliverySaverModuleName, [olyCommonModule, wowCommonModule, analyticsModule, digitalPayModule, uiRouter])
    .constant('DeliverySaverConstants', DeliverySaverConstants)
    .component('wowDeliverySaverComingSoon', DeliverySaverComingSoonComponentDefinition)
    .component('wowDeliverySaverPlanTag', DeliverySaverPlanTagComponentDefinition)
    .component('wowDeliverySaverPlanSelection', DeliverySaverPlanSelectionComponentDefinition)
    .component('wowDeliverySaverPlanGroup', DeliverySaverPlanGroupComponentDefinition)
    .component('wowDeliverySaverPlanDetail', DeliverySaverPlanDetailComponentDefinition)
    .component('wowDeliverySaverSubscriptionDetail', DeliverySaverSubscriptionDetailComponentDefinition)
    .component('wowDeliverySaverPlan', DeliverySaverPlanComponentDefinition)
    .component('wowDeliverySaverPaymentSetup', DeliverySaverPaymentSetupComponentDefinition)
    .component('wowDeliverySaverConfirmation', DeliverySaverConfirmationComponentDefinition)
    .component('wowDeliverySaverPaymentUpdate', DeliverySaverPaymentUpdateComponentDefinition)
    .component('wowDeliverySaverBillingAddress', DeliverySaverBillingAddressComponentDefinition)
    .component('wowMyDeliverySaver', MyDeliverySaverComponentDefinition)
    .component('wowMyDeliverySaverManagement', MyDeliverySaverManagementComponentDefinition)
    .component('wowMyDeliverySaverPanel', MyDeliverySaverPanelComponentDefinition)
    .component('wowMyDeliverySaverPaymentMethod', MyDeliverySaverPaymentMethodComponentDefinition)
    .component('wowMyDeliverySaverPayments', MyDeliverySaverPaymentsComponentDefinition)
    .filter('deliverySaverBillingFrequency', DeliverySaverBillingFrequency)
    .filter('deliverySaverBillingFrequencyUnit', DeliverySaverBillingFrequencyUnit)
    .filter('deliverySaverPaymentAmountHeading', DeliverySaverPaymentAmountHeading)
    .filter('deliverySaverShortName', DeliverySaverShortName)
    .filter('deliverySaverTypeName', DeliverySaverTypeName)
    .filter('deliverySaverFullTypeName', DeliverySaverFullTypeName)
    .service('DeliverySaverService', DeliverySaverService)
    .service('MyDeliverySaverService', MyDeliverySaverService)
    .service('DeliverySaverAnalytics', DeliverySaverAnalytics);

module.exports = deliverySaverModuleName;



// WEBPACK FOOTER //
// ./src/deliverysaver/deliverysaver.module.js